module.exports = __webpack_public_path__ + "img/61.8c488a2b.webp";